/* FunBug cart drawer glue: opens the drawer after any add-to-cart, and checks discount codes before applying them. */
(function () {
  if (window.FBCart) return;
  var nativeFetch = window.fetch;

  /* Public codes and their rules. Shopify only says whether a code worked, so these are used to explain WHY it didn't.
     Amounts are in paisa (Rs 997 = 99700). Keep in sync with Admin > Discounts whenever a code's conditions change.
     stacksWithBundle: true if the code combines with the "Any 2 / 3 / 4+ items" bundle discount.
     Last synced: 2026-10-18 (100OFF: Rs 100 off, min Rs 997, once per customer, stacks with bundle.
                              FUNBUGVIP: Rs 200 off, min Rs 1,997, once per customer, does NOT stack). */
  var RULES = {
    '100OFF':    { min: 99700,  once: true, firstOrder: true,  stacksWithBundle: true },
    'FUNBUGVIP': { min: 199700, once: true, firstOrder: false, stacksWithBundle: false }
  };

  function money(c) { return 'Rs. ' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function open() {
    var d = document.querySelector('cart-drawer');
    if (!d || typeof d.renderContents !== 'function') return Promise.resolve(false);
    return nativeFetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) { d.renderContents({ id: null, sections: s }); return true; })
      .catch(function () { return false; });
  }
  window.FBCart = { open: open };

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        if (res && res.ok) {
          setTimeout(open, 30);
          document.dispatchEvent(new CustomEvent('fb:cart-updated'));
        }
      }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('.fb-card__form form')) return;
    if (f.hasAttribute('data-fb-quick') || f.hasAttribute('data-fb-form')) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    if (btn) btn.disabled = true;
    window.fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  /* ---------- discount code box ---------- */
  function appliedCodes(cart) {
    var out = [];
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.type === 'discount_code') out.push(String(a.title || '').toUpperCase()); });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var a = al.discount_application || {};
        if (a.type === 'discount_code') out.push(String(a.title || '').toUpperCase());
      });
    });
    return out;
  }
  /* Total saved by automatic (non-code) discounts, i.e. the bundle discount. */
  function bundleSaving(cart) {
    var s = 0;
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a.type !== 'discount_code') s += a.total_allocated_amount || 0;
    });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var a = al.discount_application || {};
        if (a.type !== 'discount_code') s += al.amount || 0;
      });
    });
    return s;
  }
  function tryCode(code) {
    return nativeFetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function whyNot(code, after) {
    var up = code.toUpperCase();
    var rule = RULES[up];

    /* 1. Not one of our codes */
    if (!rule) {
      return up + " isn't a valid FunBug code. Check the spelling (no spaces) and try again.";
    }

    /* 2. Minimum cart total not reached (checked on the cart total before the bundle discount) */
    var sub = after.items_subtotal_price || after.original_total_price || 0;
    if (rule.min && sub < rule.min) {
      return up + ' works on orders of ' + money(rule.min) + ' or more. Your cart is ' + money(sub) +
        ', so add ' + money(rule.min - sub) + ' more to unlock it.';
    }

    /* 3. Code doesn't stack with the bundle discount, and the bundle saves more */
    var bundle = bundleSaving(after);
    if (!rule.stacksWithBundle && bundle > 0) {
      return up + " can't be used together with the bundle discount. Your bundle discount already saves you " +
        money(bundle) + ', which is the better deal, so we kept it.';
    }

    /* 4. Once-per-customer code already used */
    if (rule.once) {
      return up + ' can only be used once per customer' + (rule.firstOrder ? ' (first order only)' : '') +
        ', and it looks like it has already been used on your account.';
    }

    return up + " couldn't be applied to this cart. WhatsApp us and we'll sort it out.";
  }
  function msgEl(kind) {
    var sel = kind === 'ok' ? '[data-fb-code-ok]' : '[data-fb-code-err]';
    var el = document.querySelector(sel);
    if (!el && kind === 'ok') {
      var err = document.querySelector('[data-fb-code-err]');
      if (err) {
        el = document.createElement('p');
        el.className = 'fbk-code-ok';
        el.setAttribute('data-fb-code-ok', '');
        el.hidden = true;
        err.parentNode.insertBefore(el, err.nextSibling);
      }
    }
    return el;
  }
  function show(kind, text) {
    var ok = msgEl('ok'), err = msgEl('err');
    if (ok) ok.hidden = true;
    if (err) err.hidden = true;
    var el = kind === 'ok' ? ok : err;
    if (el && text) { el.textContent = text; el.hidden = false; }
  }
  var busy = false;
  function applyCode() {
    if (busy) return;
    var input = document.querySelector('[data-fb-code]');
    var btn = document.querySelector('[data-fb-code-apply]');
    if (!input) return;
    var code = input.value.trim().replace(/\s+/g, '');
    if (!code) { show('err', 'Enter a discount code first.'); input.focus(); return; }
    busy = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Checking...'; }
    show('err', '');
    var before = null;
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (b) {
        before = b;
        if (appliedCodes(b).indexOf(code.toUpperCase()) > -1) {
          show('ok', code.toUpperCase() + ' is already applied to your cart.');
          return null;
        }
        return tryCode(code);
      })
      .then(function (after) {
        if (!after) return;
        var up = code.toUpperCase();
        if (appliedCodes(after).indexOf(up) > -1) {
          var prev = appliedCodes(before)[0];
          var replaced = prev && prev !== up && appliedCodes(after).indexOf(prev) === -1;
          var stacked = RULES[up] && RULES[up].stacksWithBundle && bundleSaving(after) > 0;
          return open().then(function () {
            var msg = up + ' applied.';
            if (stacked) msg += ' It stacks with your bundle discount.';
            if (replaced) msg += ' It replaced ' + prev + ', since only one code works per order.';
            show('ok', msg);
            var i2 = document.querySelector('[data-fb-code]'); if (i2) i2.value = '';
          });
        }
        var prevCode = appliedCodes(before)[0];
        var restore = prevCode ? tryCode(prevCode) : Promise.resolve(null);
        if (!prevCode) { try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (x) {} }
        return restore.then(function () { show('err', whyNot(code, after)); });
      })
      .catch(function () { show('err', "Couldn't check that code. Check your connection and try again."); })
      .then(function () {
        busy = false;
        var b2 = document.querySelector('[data-fb-code-apply]');
        if (b2) { b2.disabled = false; b2.textContent = 'Apply'; }
      });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-fb-code-apply]')) { e.preventDefault(); applyCode(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-fb-code]')) { e.preventDefault(); applyCode(); }
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-fb-code]')) show('err', '');
  });

  if (/[?&]open_cart=1/.test(window.location.search)) {
    var go = function () {
      customElements.whenDefined('cart-drawer').then(function () {
        open();
        try {
          var clean = window.location.pathname + window.location.search.replace(/([?&])open_cart=1&?/, '$1').replace(/[?&]$/, '') + window.location.hash;
          history.replaceState(null, '', clean);
        } catch (x) {}
      });
    };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
  }
})();
